import { Anchor, Flex } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import IconWithText from 'components/shared/IconWithText';
import ImageWithSkeleton from 'components/shared/ImageWithSkeleton';
import Text from 'components/shared/Text';
import { useRootStore } from 'stores/global/RootStore/context';
import { useLkLayoutStore } from 'stores/local/layout/LkLayoutStore';

import s from './SocialLinks.module.scss';

const SocialLinks: React.FC = () => {
  const { menu } = useLkLayoutStore();
  const {
    generalInformationStrapi: { socialLinks },
  } = useRootStore();

  if (socialLinks.value.length === 0) {
    return null;
  }

  if (!menu.isOpen) {
    return (
      <Flex direction="column" align="center" gap="xs">
        {socialLinks.value.map((link) => (
          <Anchor key={link.id} href={link.url} target="_blank" h={20}>
            <ImageWithSkeleton urlImage={link.logo.url} height="20px" maxHeightImage="20px" width="20px" />
          </Anchor>
        ))}
      </Flex>
    );
  }

  return (
    <Flex direction="column" gap="xs" px="md" py="sm" className={s.root}>
      <Text size="xs" c="gray.6" fw={600}>
        Мы в соц. сетях
      </Text>
      <Flex direction="column" gap="xxxs">
        {socialLinks.value.map((link) => (
          <IconWithText key={link.id} icon={link.logo} text={link.name} url={link.url} />
        ))}
      </Flex>
    </Flex>
  );
};

export default observer(SocialLinks);
